'use client';

import { ReactElement, ReactNode } from 'react';

import type { Brand } from '../types/brand';

import { BrandContext } from './BrandContext';

export interface BrandProviderProps {
    brand: Brand;
    children: ReactNode;
}

/**
 * Makes the brand (logo, name, favicons) available to components through `useBrand()`. Wrap the app once,
 * at the root, next to `BrandStyle`.
 *
 * @example
 * <BrandProvider brand={brand}>{children}</BrandProvider>
 */
export function BrandProvider({ brand, children }: BrandProviderProps): ReactElement {
    return <BrandContext.Provider value={brand}>{children}</BrandContext.Provider>;
}
